import BasicModel from '../basic/BasicModel'
export default {
  getDataCompare(vm, params, listener) {
    let action = 'data/getDataCompare.action'
    BasicModel.get(vm, action, null, listener)
  },
  findChannelDataList(vm, params, listener) {
    let action = 'data/findChannelDataList.action'
    BasicModel.get(vm, action, params, listener)
  },
  findBusinessDataList(vm, params, listener) {
    let action = 'data/findBusinessDataList.action'
    BasicModel.get(vm, action, params, listener)
  },
  findDataTrend(vm, params, listener) {
    let action = 'data/findDataTrend.action'
    BasicModel.get(vm, action, params, listener)
  },
  findDataDetail(vm, params, listener) {
    let action = 'data/findDataDetail.action'
    BasicModel.get(vm, action, params, listener)
  }



}
